<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<br/><p style="text-indent:00em;">Blagomira Halacheva – Boggie – was born in Bulgaria. She graduated from medical college in Plovdiv and now she practices in Austria. Her son Rosen lives with his family in Wales, UK. The novel <em>8 Seconds</em> was ranked second in the competition for a Bulgarian novel of the Bukvite Foundation.</p>
<br/><p style="text-indent:00em;">A film script was written based on the novel. The Silent World Publishing House published the first book titled <em>Children of Sin</em>, the second book <em>Traps for Love and Power</em>, and the third book of the trilogy, <em>Redemption,</em> of the Maria-Magdalene Trilogy.</p>
<br/><p style="text-indent:00em;">In 2014 at the Screen-Craft Family-Friendly Script Contest, the script <em>Double Dimension</em> by Blagomira Halacheva qualified of the Quarter-Finalists.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?307d64ac